/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import * as React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"

import Header from "./header"
import "./layout.css"
import "./text.css"

const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <div class="row">
      <Header siteTitle={data.site.siteMetadata?.title || `Title`} />
        <main>{children}</main>
        <footer class="p-1 text-center"
            style={{
              backgroundRepeat: 'repeat',
              backgroundImage: `url(${('https://1.bp.blogspot.com/-Mw0xEaVY3aw/YWxR8l4N5BI/AAAAAAAAKPA/__XP598b-qwL__tfZ5ia4UNL-EHcT3h-wCLcBGAsYHQ/s84/bgs.jpg')})`
        }}
        >
          © <a href="/" class="text-dark">whatshop</a> {new Date().getFullYear()}<br/> Built with
          {` `}
          <a href="https://www.gatsbyjs.com" class="text-dark" rel="noreferrer" target="_blank">Gatsby</a> Repo on <a href="https://www.github.com" rel="noreferrer" class="text-dark" target="_blank">Github</a> Host by <a href="https://www.vercel.com" rel="noreferrer" class="text-dark" target="_blank">Vercel</a>
        </footer>
     </div>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
